import React, { useState } from "react";

const Delivery = () => {
    const [showProductDetails, setShowProductDetails] = useState(false);

    // Function to handle the click on the terms and conditions link
    const handleClick = () => {
      // Show product details when Terms and Conditions are clicked
      setShowProductDetails(true);
  
      // Set a timer to hide the product details after 5 seconds (for example)
      setTimeout(() => {
        setShowProductDetails(false);
      }, 50000); // 5000ms = 5 seconds
    };
  
    return (
      <div>
        {/* Terms and Conditions anchor */}
        <a href="#terms" onClick={handleClick}>
        Shipping & Delivery
        </a>
  
        {/* Product Details section */}
        {showProductDetails && (
          <div className="product-details">
            <h2>Shipping & Delivery</h2>
            
            <p>We offer reliable shipping and delivery services for all electronic products across Bangladesh. For orders within Dhaka, delivery is completed within 5 business days. For locations outside Dhaka, please allow up to 10 business days for your order to arrive. We work with trusted courier partners to ensure your products are delivered safely and on time. Once your order is confirmed, you will receive tracking details to monitor its progress.</p>
          </div>
        )}
      </div>
    );
  
};

export default Delivery;